// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_row__8lnlf {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    grid-gap: 32px;
    color: #0c3b8d;
    --item-min-height: 160px;
}

.styles_selection__HrD3I {
}

.styles_main__nHyP4 {
    padding: 20px 40px;
}

.styles_row__8lnlf:not(.styles_secondary__wuUq6) {
    background: #f0f3f7;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

.styles_column__ox4T\\+ {
    /*border: 1px dashed var(--light-grey);*/
    /*background: #fff;*/
    /*width: 260px;*/
    display: flex;
    align-items: center;
    justify-content: space-between;
    /*height: 44px;*/
    /*max-width: 300px;*/
    /*flex: 1;*/
    /*width: 31.6%;*/
}

.styles_flex__a1YRT {
    display: flex;
    grid-gap: 10px;
}

.styles_column__ox4T\\+ input {
    border: 0;
}

.styles_column__ox4T\\+:first-letter {
    text-transform: capitalize;
}

.styles_rounded__CLv3k {
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.styles_column__ox4T\\+:not(.styles_rounded__CLv3k) {
    text-align: center;
}

.styles_sm__XA1UT {
    max-width: 194px;
    flex: 1 1;
}

.styles_note__HLYCV {
    margin: auto 0;
}

.styles_inputWrapper__6eNhw {
    position: relative;
}

.styles_icon__djBhM {
    position: absolute;
    top: 10px;
    width: 25px;
    height: 25px;
    margin-left: -35px;
}

.styles_icon__djBhM span {
    height: 100%;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_sm__XA1UT {
        width: 78px;
    }

    .styles_column__ox4T\\+ {
        padding: 10px 15px;
        height: 40px;
    }

    .styles_icon__djBhM {
        top: 6px;
        margin-left: -28px;
        width: 20px;
        height: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectionPopup/SelectionRowCompact/styles.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,wBAAwB;AAC5B;;AAEA;AACA;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;IACxC,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":["@value screen-md-max from '../../../breakpoints.css';\n\n.row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n    grid-gap: 32px;\n    color: #0c3b8d;\n    --item-min-height: 160px;\n}\n\n.selection {\n}\n\n.main {\n    padding: 20px 40px;\n}\n\n.row:not(.secondary) {\n    background: #f0f3f7;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n}\n\n.column {\n    /*border: 1px dashed var(--light-grey);*/\n    /*background: #fff;*/\n    /*width: 260px;*/\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    /*height: 44px;*/\n    /*max-width: 300px;*/\n    /*flex: 1;*/\n    /*width: 31.6%;*/\n}\n\n.flex {\n    display: flex;\n    grid-gap: 10px;\n}\n\n.column input {\n    border: 0;\n}\n\n.column:first-letter {\n    text-transform: capitalize;\n}\n\n.rounded {\n    border-radius: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.column:not(.rounded) {\n    text-align: center;\n}\n\n.sm {\n    max-width: 194px;\n    flex: 1;\n}\n\n.note {\n    margin: auto 0;\n}\n\n.inputWrapper {\n    position: relative;\n}\n\n.icon {\n    position: absolute;\n    top: 10px;\n    width: 25px;\n    height: 25px;\n    margin-left: -35px;\n}\n\n.icon span {\n    height: 100%;\n}\n\n@media screen-md-max {\n    .sm {\n        width: 78px;\n    }\n\n    .column {\n        padding: 10px 15px;\n        height: 40px;\n    }\n\n    .icon {\n        top: 6px;\n        margin-left: -28px;\n        width: 20px;\n        height: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"row": `styles_row__8lnlf`,
	"selection": `styles_selection__HrD3I`,
	"main": `styles_main__nHyP4`,
	"secondary": `styles_secondary__wuUq6`,
	"column": `styles_column__ox4T+`,
	"flex": `styles_flex__a1YRT`,
	"rounded": `styles_rounded__CLv3k`,
	"sm": `styles_sm__XA1UT`,
	"note": `styles_note__HLYCV`,
	"inputWrapper": `styles_inputWrapper__6eNhw`,
	"icon": `styles_icon__djBhM`
};
export default ___CSS_LOADER_EXPORT___;
